// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"thankyou__msignaturepad___c-uxz","m-signature-pad--body":"thankyou__m-signature-pad--body___3ifWy","m-signature-pad--footer":"thankyou__m-signature-pad--footer___BKmUv","description":"thankyou__description___B774x","button":"thankyou__button___2DPWH","clear":"thankyou__clear___3UqcU","save":"thankyou__save___3AcKW","m-signature-pad":"thankyou__m-signature-pad___3I4E0","github":"thankyou__github___pfW-P","wrapper":"thankyou__wrapper___26CND","card":"thankyou__card___2P8Wl","spLogo":"thankyou__spLogo___yEpx8"};


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/refigure/thankyou/thankyou.scss
// module id = IGnt
// module chunks = client